const buildSalesFormData = (payload, prescriptionFile) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    // Arrays & Objects → JSON
    if (typeof value === "object" && !(value instanceof File)) {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });

  if (prescriptionFile) {
    formData.append("prescription", prescriptionFile);
  }

  return formData;
};
export default buildSalesFormData;